import React from "react";
import styled from "styled-components";
import media from "styled-media-query";

// API
import { useInView } from "react-intersection-observer";

// Styles
import { getFontWeight } from "../../../styles/font-weight";
import { colors } from "../../../styles/colors";

export const SectionTitle = (props) => {
  const [ref, inView] = useInView({
    rootMargin: "-100px 0px",
  });

  return (
    <StyledDivRootContainer ref={ref} className={inView ? "visible" : ""}>
      - {props.title} -
    </StyledDivRootContainer>
  );
};

const StyledDivRootContainer = styled.div`
  display: block;
  color: ${colors.logo_orange};
  text-align: center;

  ${getFontWeight("Medium")};

  ${media.lessThan("small")`
    padding: 16px 0px;
    font-size: 16px;
  `};

  ${media.greaterThan("medium")`
    padding: 48px 0px;
    font-size: 46px;
  `};

  transition: all 800ms 0.1s ease;
  opacity: 0;
  &.visible {
    opacity: 1;
  }
`;
